import React from 'react';
import { Card, CardHeader, CardBody } from '../ui/Card';
import { StarIcon, TrendingUpIcon, UsersIcon } from 'lucide-react';
export function SocialProof() {
  const testimonials = [{
    type: 'SaaS Scale-Up',
    people: '28 people',
    result: '+24% eNPS',
    pipeline: '$180k idea pipeline',
    quote: 'Our team came back energized and full of ideas. The beachside strategy sessions were particularly productive.',
    company: 'Tech Company',
    role: 'VP of People'
  }, {
    type: 'Sales Incentive',
    people: '42 people',
    result: '97% satisfaction',
    pipeline: '18% sales increase',
    quote: 'The perfect balance of luxury and team building. Our top performers felt truly rewarded and motivated.',
    company: 'Insurance Provider',
    role: 'Sales Director'
  }, {
    type: 'Executive Retreat',
    people: '16 people',
    result: '3× idea velocity',
    pipeline: 'Strategic roadmap',
    quote: "The change of environment sparked conversations and breakthroughs that wouldn't have happened in our boardroom.",
    company: 'Creative Agency',
    role: 'CEO'
  }];
  return <section className="py-16 bg-white" data-id="element-267">
      <div className="container mx-auto px-4 md:px-6" data-id="element-268">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-269">
          <h2 className="text-3xl md:text-4xl font-bold text-[#374047] mb-4" data-id="element-270">
            Success Stories
          </h2>
          <p className="text-lg text-[#374047]/80" data-id="element-271">
            See how our clients achieved measurable business results.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-272">
          {testimonials.map((testimonial, index) => <Card key={index} className="h-full hover:shadow-lg transition-shadow" data-id="element-273">
              <CardHeader data-id="element-274">
                <div className="flex justify-between items-start mb-4" data-id="element-275">
                  <div data-id="element-276">
                    <h3 className="text-xl font-bold text-[#374047]" data-id="element-277">
                      {testimonial.type}
                    </h3>
                    <p className="text-sm text-[#374047]/60" data-id="element-278">
                      {testimonial.people}
                    </p>
                  </div>
                  <div className="flex" data-id="element-279">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 text-[#FF6B65]" fill="#FF6B65" data-id="element-280" />)}
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 mb-4" data-id="element-281">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#0099A1]/10 text-[#0099A1]" data-id="element-282">
                    <TrendingUpIcon className="h-3 w-3 mr-1" data-id="element-283" />
                    {testimonial.result}
                  </span>
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#0099A1]/10 text-[#0099A1]" data-id="element-284">
                    <UsersIcon className="h-3 w-3 mr-1" data-id="element-285" />
                    {testimonial.pipeline}
                  </span>
                </div>
              </CardHeader>
              <CardBody data-id="element-286">
                <blockquote className="italic text-[#374047]/80 mb-4" data-id="element-287">
                  "{testimonial.quote}"
                </blockquote>
                <div className="text-right" data-id="element-288">
                  <p className="text-sm font-medium text-[#374047]" data-id="element-289">
                    {testimonial.role}
                  </p>
                  <p className="text-xs text-[#374047]/60" data-id="element-290">
                    {testimonial.company}
                  </p>
                </div>
              </CardBody>
            </Card>)}
        </div>
      </div>
    </section>;
}